import { useContext } from 'react';
import useSWR from 'swr';
import { AuthContext } from 'react-auth';
import { ModalContext } from 'mc-react-redux-modal';
import authMiddleware from 'root/middlewares/auth';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

export const useAuth = () => {
  const { actionsUser, dispatchUser, stateUser } = useContext(AuthContext);
  const { modalActions, modalState } = useContext(ModalContext);

  const actionsAuth = actionsUser(authMiddleware({ modalActions, dispatchUser, getState: modalState }));

  return {
    actionsAuth,
    stateUser: publicRuntimeConfig.modules_auth ? stateUser : {}
  };
};

export default useAuth;

export const SWRProvider = () => {
  const { actionsAuth } = useAuth();

  useSWR(publicRuntimeConfig.modules_auth ? `${publicRuntimeConfig.BASE_API_URL}/users/me` : null, () => actionsAuth.fetchUserByToken());

  return [];
};
